import Breadcrumbs from "components/Common/Breadcrumb"
import SButton from "components/Common/Button"
import SelectBox from "components/Common/SelectBox"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import Table from "./Table"
import { useHistory } from "react-router-dom"
import {
  getOrderAPI,
  getOrderCSVApi,
  getOrderGrandTotalApi,
  getOrderStatusList,
  getOrderSubTotalApi,
} from "helpers/order"
import Skeleton from "react-loading-skeleton"
import DateInput from "components/Common/DateInput"
import { getProductListAPI } from "helpers/product_helper"
import moment from "moment"

export default function Orders() {
  const history = useHistory()
  const [data, setData] = useState([])
  const [isFetching, setIsFetching] = useState(false)

  const [filter, setFilter] = useState({
    supplierName: "",
    storeName: "",
    customerName: "",
    type: "",
    productId: "",
    orderDateFrom: "",
    orderDateTo: "",
    scheduledDeliveryDateFrom: "",
    scheduledDeliveryDateTo: "",
    deliveryDateFrom: "",
    deliveryDateTo: "",
    paymentStatusId: "",
    orderStatusId: "",
  })

  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [count, setCount] = useState(100)
  const [productValue, setProductValue] = useState({ value: "", label: "" })
  const [type, setType] = useState({ value: "", label: "" })
  const [productOptions, setProductOptions] = useState([])
  const [paymentStatus, setPaymentStatus] = useState({ value: "", label: "" })
  const [orderStatusValue, setOrderStatusValue] = useState({
    value: "",
    label: "",
  })
  const [orderStatusOptions, setOrderStatusOptions] = useState([])
  const [subNGrandTotal, setSubNGrandTotal] = useState({
    subTotal: {},
    grandTotal: {},
  })

  const [disabledDates, setDisabledDates] = useState({
    orderDateFrom: [],
    orderDateTo: [],
    scheduledDeliveryDateFrom: [],
    scheduledDeliveryDateTo: [],
    deliveryDateFrom: [],
    deliveryDateTo: [],
  })

  const [activePage, setActivePage] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const onFilter = e => {
    const { name, value } = e.target
    setFilter({ ...filter, [name]: value })
  }

  const params = {
    ...filter,
    page: activePage,
    size: size,
  }

  const fetchData = async params => {
    const _params = Object.fromEntries(
      Object.entries(params).filter(val => val[1] !== "")
    )
    setIsFetching(true)
    try {
      const grandTotal = await fetchGrandTotal(params)
      const subTotal = await fetchSubTotal(params)
      let res = await getOrderAPI(_params)
      if (res.status === 200) {
        setSubNGrandTotal({ grandTotal, subTotal })
        setData(res.data.content)
        setCount(res.data.totalPages)
        setTotalPages(res.data.totalPages)
        setTimeout(() => {
          setIsFetching(false)
        }, 20)
      }
    } catch (error) {
      console.log("err: ", error.response)
    }
  }

  const fetchSubTotal = async params => {
    try {
      const { data } = await getOrderSubTotalApi(params)
      return data
    } catch (error) {
      console.error(error)
    }
  }

  const fetchGrandTotal = async params => {
    try {
      const { data } = await getOrderGrandTotalApi(params)
      return data
    } catch (error) {
      console.error(error)
    }
  }

  const fetchProducts = async () => {
    try {
      const { data } = await getProductListAPI()
      if (data.length) {
        const _products = data.map(item => ({
          value: item.id,
          label: item.productName,
        }))
        setProductOptions(_products)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchOrderStatus = async () => {
    try {
      const { data } = await getOrderStatusList()
      setOrderStatusOptions(
        data.map(({ name, id }) => ({
          label: name,
          value: id,
        }))
      )
    } catch (error) {
      console.error("Error getting order status", error)
    }
  }

  const onSearch = () => {
    fetchData(params)
  }

  const onProductSelect = e => {
    setProductValue(e ? e : "")
    setFilter({ ...filter, productId: e.value })
  }

  const onOrderStatusSelect = e => {
    if (!e) {
      setOrderStatusValue("")
      setFilter({ ...filter, orderStatusId: "" })
      return
    }
    setFilter({
      ...filter,
      orderStatusId: e.value,
    })
    setOrderStatusValue(e)
  }

  const getDisabledDates = (d, fIdx) => {
    const aYearInMillis = 31556952000
    const appendZero = n => (n > 9 ? n : `0${n}`)
    const disablePrevDates = d => {
      if (!d) return []
      const aYearBack = new Date(new Date(d).getTime() - aYearInMillis)
        .toISOString()
        .slice(0, 10)
      return [{ from: aYearBack, to: d }]
    }

    const disableNextDates = d => {
      if (!d) return []
      const aYearFromNow = new Date(new Date(d).getTime() + aYearInMillis)
        .toISOString()
        .slice(0, 10)
      const dArr = d.split("-")
      const todaysDate = +dArr[2] + 2
      dArr.splice(2, 1, `${todaysDate}`)
      return [{ from: dArr.join("-"), to: aYearFromNow }]
    }

    const disabledFuncs = [disablePrevDates, disableNextDates]
    return disabledFuncs[fIdx](d)
  }
  const onDateChange = obj => {
    const { type, val } = obj
    // const _date = new Date(val).toISOString().slice(0, 10)
    const _date = moment(val[0]).format("YYYY-MM-DD")

    const dateMaps = {
      deliveryDateFrom: ["deliveryDateTo", 0],
      deliveryDateTo: ["deliveryDateFrom", 1],
      orderDateFrom: ["orderDateTo", 0],
      orderDateTo: ["orderDateFrom", 1],
      scheduledDeliveryDateFrom: ["scheduledDeliveryDateTo", 0],
      scheduledDeliveryDateTo: ["scheduledDeliveryDateFrom", 1],
    }

    const _disabledDate = getDisabledDates(_date, dateMaps[type][1])
    const _disabledDates = {
      ...disabledDates,
      [dateMaps[type][0]]: _disabledDate,
    }

    setDisabledDates(_disabledDates)
    setFilter({ ...filter, [type]: _date })
  }

  const onTypeChange = val => {
    setType(val ? val : "")
    setFilter({ ...filter, type: val ? val.value : "" })
  }

  const onPaymentStatusChange = val => {
    if (!val) {
      setPaymentStatus({ label: "", value: "" })
      const _filter = { ...filter }
      delete _filter.paymentStatusId
      setFilter(_filter)
      return
    }
    setPaymentStatus(val)
    setFilter({ ...filter, paymentStatusId: val.value })
  }

  const downloadCSV = async () => {
    try {
      const { data } = await getOrderCSVApi(filter)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "text/csv;charset=utf-8;" })
      )
      link.setAttribute("download", "order" + new Date().getTime() + ".csv")
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchData(params)
    fetchProducts()
    fetchOrderStatus()
  }, [])

  const redirectToEdit = (id, path) => {
    const _path = path === "/repair" ? "/orders/edit/repair" : `/orders/edit`
    history.push({
      pathname: _path,
      search: `?id=${id}`,
      state: { id: id },
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"受注一覧"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row className="row-gap-3">
              <Col xl={2} md={4}>
                <TextInputWithLabel
                  label={"取引先"}
                  placeholder={""}
                  value={filter.supplierName}
                  type="text"
                  name="supplierName"
                  onChange={onFilter}
                />
              </Col>
              <Col xl={2} md={4}>
                <TextInputWithLabel
                  label={"店舗"}
                  placeholder={""}
                  value={filter.storeName}
                  type="text"
                  name="storeName"
                  onChange={onFilter}
                />
              </Col>
              <Col xl={2} md={4}>
                <TextInputWithLabel
                  label={"顧客名"}
                  placeholder={""}
                  value={filter.customerName}
                  type="text"
                  name="customerName"
                  onChange={onFilter}
                />
              </Col>
              <Col xl={2} md={4}>
                <SelectBox
                  label={"区分"}
                  placeholder={""}
                  value={type}
                  name="division"
                  options={[
                    { value: "Bespoke", label: "Bespoke" },
                    { value: "MTM", label: "MTM" },
                  ]}
                  onChange={onTypeChange}
                />
              </Col>
              <Col xl={2} md={4}>
                <SelectBox
                  label={"商品"}
                  placeholder={""}
                  value={productValue}
                  name="product"
                  options={productOptions}
                  onChange={onProductSelect}
                />
              </Col>
              <Col xl={2} md={4}>
                <SelectBox
                  label="ステータス"
                  options={orderStatusOptions}
                  value={orderStatusValue}
                  onChange={onOrderStatusSelect}
                />
              </Col>
            </Row>
            <Row className="row-gap-3 mt-3">
              <Col xl={4} md={6}>
                <Label>受注日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    value={filter.orderDateFrom}
                    className="form-control"
                    onChange={val =>
                      onDateChange({ val, type: "orderDateFrom" })
                    }
                    disabledDates={disabledDates.orderDateFrom}
                    clear={() => setFilter({ ...filter, orderDateFrom: "" })}
                  />
                  <span>~</span>
                  <DateInput
                    value={filter.orderDateTo}
                    className="form-control"
                    onChange={val => onDateChange({ val, type: "orderDateTo" })}
                    disabledDates={disabledDates.orderDateTo}
                    clear={() => setFilter({ ...filter, orderDateTo: "" })}
                  />
                </div>
              </Col>
              <Col xl={4} md={6}>
                <Label>納品予定日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    onChange={val =>
                      onDateChange({ val, type: "scheduledDeliveryDateFrom" })
                    }
                    disabledDates={disabledDates.scheduledDeliveryDateFrom}
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateFrom: "" })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    onChange={val =>
                      onDateChange({ val, type: "scheduledDeliveryDateTo" })
                    }
                    disabledDates={disabledDates.scheduledDeliveryDateTo}
                    clear={() =>
                      setFilter({ ...filter, scheduledDeliveryDateTo: "" })
                    }
                  />
                </div>
              </Col>
              <Col xl={4} md={6}>
                <Label>納品日</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    onChange={val =>
                      onDateChange({ val, type: "deliveryDateFrom" })
                    }
                    disabledDates={disabledDates.deliveryDateFrom}
                    clear={() => setFilter({ ...filter, deliveryDateFrom: "" })}
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    onChange={val =>
                      onDateChange({ val, type: "deliveryDateTo" })
                    }
                    disabledDates={disabledDates.deliveryDateTo}
                    clear={() => setFilter({ ...filter, deliveryDateTo: "" })}
                  />
                </div>
              </Col>
              <Col xl={2} md={4}>
                <SelectBox
                  label="支払いステータス"
                  options={[
                    { value: "未入金", label: "未入金" },
                    { value: " 一部入金", label: "一部入金" },
                    { value: "入金済み", label: "入金済み" },
                  ]}
                  value={paymentStatus}
                  onChange={onPaymentStatusChange}
                />
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-4 mb-2">
              <SButton className="mx-2 button" onClick={() => onSearch()}>
                検索
              </SButton>
              <SButton className="mx-2 button" onClick={downloadCSV}>
                CSV出力
              </SButton>
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-end my-2">
              <SButton
                onClick={() => history.push("/orders/create")}
                className="button"
              >
                新規受注
              </SButton>
            </div>
            <Row>
              {isFetching ? (
                <Skeleton count={5} />
              ) : (
                <>
                  <Table
                    page={page}
                    size={size}
                    count={count}
                    content={data}
                    setSize={size => {
                      let _filter = { ...params }
                      _filter.size = size
                      fetchData(_filter)
                      setSize(size)
                    }}
                    setPage={page => {
                      let _filter = { ...params }
                      _filter.page = page
                      fetchData(_filter)
                      setPage(page)
                    }}
                    redirect={redirectToEdit}
                    total={subNGrandTotal}
                  />
                </>
              )}
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
